const YesNoFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/yesNoFilter/yesNoFilter.tpl.html',
    controller: 'yesNoFilterController',
    bindings: {
        criterionTemplate: '<',
        advancedFilterType: '<',
        translationsKey: '<?'
    }
};

angular.module('umCore')
    .component('uiYesNoFilter', YesNoFilterComponent);
